(() => {
  'use strict';
  // Meruvio: rebrand de la guía para el navegador interno de TikTok (antes VistaRacer)
  const rebrand = () => {
    const guide = document.getElementById('vr-tiktok-guide');
    if (!guide) return;
    const logo = guide.querySelector('.vr-guide-logo');
    if (logo) logo.textContent = 'M';
    const name = guide.querySelector('.vr-guide-brand span:last-child');
    if (name) name.textContent = 'Meruvio';
    const trust = guide.querySelector('.vr-guide-trust');
    if (trust) trust.textContent = '🔒 Du bleibst sicher auf meruvio.de';
    guide.querySelectorAll('.vr-guide-logo, .vr-guide-number').forEach((el) => { el.style.background = '#0088FE'; });
    guide.querySelectorAll('.vr-guide-icon, .vr-guide-label, .vr-guide-arrow').forEach((el) => { el.style.color = '#0088FE'; });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rebrand, { once: true });
  } else {
    rebrand();
  }
})();
